/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoryMemoRequest } from '../models/HistoryMemoRequest';
import type { PaginatedResponse_TaskItemResponse_ } from '../models/PaginatedResponse_TaskItemResponse_';
import type { TaskItemCheckRequest } from '../models/TaskItemCheckRequest';
import type { TaskItemCreateRequest } from '../models/TaskItemCreateRequest';
import type { TaskItemDateRangeResponse } from '../models/TaskItemDateRangeResponse';
import type { TaskItemResponse } from '../models/TaskItemResponse';
import type { TaskItemSortRequest } from '../models/TaskItemSortRequest';
import type { TaskItemUpdateRequest } from '../models/TaskItemUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskItemService {
    /**
     * Get Task Item Date Range
     * 워크스페이스 수행업무 날짜 범위 조회
     *
     * 해당 워크스페이스의 삭제되지 않은 수행업무 중 가장 빠른 시작일과 가장 늦은 종료일을 반환합니다.
     * @returns TaskItemDateRangeResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskItemDateRange({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<TaskItemDateRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/item/date-range',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Task Item
     * 수행업무 생성
     *
     * 새로운 수행업무를 생성합니다.
     * @returns TaskItemResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskItem({
        requestBody,
    }: {
        requestBody: TaskItemCreateRequest,
    }): CancelablePromise<TaskItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Items
     * 수행업무 목록 조회 및 검색
     *
     * 수행업무를 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * q: 검색 키워드 (선택사항)
     * task_id: 세부실행과제 ID로 필터링 (선택사항)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * start_date: 시작일 (YYYY-MM-DD 형식, end_date와 함께 사용)
     * end_date: 종료일 (YYYY-MM-DD 형식, start_date와 함께 사용)
     * department_id: 부서 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * assignee_id: 담당자 ID로 필터링 (선택사항)
     * sub_assignee_id: 부담당자 ID로 필터링 (선택사항)
     * manager_id: 관리자 ID로 필터링 (선택사항)
     * reviewer_id: 검토자 ID로 필터링 (선택사항)
     * stakeholder_id: 이해관계자 ID (OR 조건으로 모든 역할 검색, 선택사항)
     * status: 수행업무 상태 필터 ("incomplete" | "assigned" | "completed" | "reviewed", 선택사항)
     * @returns PaginatedResponse_TaskItemResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskItems({
        workspaceId,
        q,
        taskId,
        page = 1,
        perPage = 100,
        startDate,
        endDate,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        status,
    }: {
        workspaceId: string,
        q?: string,
        taskId?: string,
        page?: number,
        perPage?: number,
        startDate?: string,
        endDate?: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        status?: string,
    }): CancelablePromise<PaginatedResponse_TaskItemResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/item',
            query: {
                'workspace_id': workspaceId,
                'q': q,
                'task_id': taskId,
                'page': page,
                'per_page': perPage,
                'start_date': startDate,
                'end_date': endDate,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Item
     * 수행업무 조회
     *
     * ID로 특정 수행업무를 조회합니다.
     * @returns TaskItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<TaskItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Item
     * 수행업무 정보 수정
     *
     * 특정 수행업무의 정보를 수정합니다.
     * @returns TaskItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskItem({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: TaskItemUpdateRequest,
    }): CancelablePromise<TaskItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Item
     * 수행업무 삭제
     *
     * 특정 수행업무를 삭제합니다. (소프트 삭제)
     * 선택적으로 body 에 memo 를 담으면 history 에 기록됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskItem({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody?: HistoryMemoRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Item Sort
     * 수행업무 정렬 순서 변경
     *
     * 수행업무의 정렬 순서를 변경합니다.
     * prev_task_item_id: 이동할 위치의 이전 수행업무 ID (맨 앞이면 None)
     * next_task_item_id: 이동할 위치의 다음 수행업무 ID (맨 뒤면 None)
     * @returns TaskItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskItemSort({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: TaskItemSortRequest,
    }): CancelablePromise<TaskItemResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/item/{item_id}/sort',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Check Task Item
     * 수행업무 검토/승인
     *
     * 담당자, 관리자 또는 검토자가 수행업무를 검토하고 승인/반려합니다.
     * type에 따라 assignee, manager 또는 reviewer 권한을 확인하고,
     * approved 값에 따라 승인 여부를 결정합니다.
     * @returns TaskItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsCheckTaskItem({
        taskItemId,
        requestBody,
    }: {
        taskItemId: string,
        requestBody: TaskItemCheckRequest,
    }): CancelablePromise<TaskItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/item/{task_item_id}/check',
            path: {
                'task_item_id': taskItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
